import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";

const ViewFilesModal = ({ isOpen, setIsOpen, question }) => {
  const [documents, setDocuments] = useState([]);
  const defaultRender = (value) => (value ? value : "--");

  const columns = [
    {
      title: "File Name",
      dataIndex: "original_name",
      render: defaultRender,
    },
    {
      title: "Action",
      dataIndex: "view_file",
      render: defaultRender,
    },
  ];

  useEffect(() => {
    const allDocs = Object?.values(question?.documents || {}).flat();
    setDocuments(
      allDocs?.map((data) => {
        return {
          original_name: (
            <div className={`sub-title highlight-text}`}>
              {data?.original_name || "--"}
            </div>
          ),
          view_file: (
            <a
              href={data?.path}
              target="_blank"
              className="text-blue-500"
            >
              View File
            </a>
          ),
        };
      })
    );
  }, [question]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"View Files"}
      width={800}
    >
      <SkeletonTable columns={columns} data={documents} />
    </ModalComponent>
  );
};

export default ViewFilesModal;
